import styled from '@emotion/styled'

import { Typo16IceBlueTwoDINM } from '../../../../../themes/Fonts/Din2014'
import { maxDeviceWidth, customDevice } from '../../../../../utils/mixins'

import CloudinaryS3LazyLoadedImage from '../../../../CloudinaryS3LazyLoadedImage'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${maxDeviceWidth(767)} {
    width: 45%;
    margin-bottom: 60px;
    &:last-child {
      margin-bottom: 0px;
    }

    &:nth-last-child(2) {
      margin-bottom: 0px;
    }
  }

  ${maxDeviceWidth(500)} {
    width: 100%;
    &:nth-last-child(2) {
      margin-bottom: 60px;
    }
  }
`

export const Image = styled(CloudinaryS3LazyLoadedImage)`
  max-width: 138px;
  height: auto;
  margin-bottom: 27px;
`

export const Text = styled(Typo16IceBlueTwoDINM)`
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PlacesToPlayIbcricket/PlacesListToPlayIbcricket/PlaceToPlayIbcricket/styledComponents.js